import React from 'react';
import NeighborhoodPainPost from '../components/NeighborhoodPainPost';

const BlogPostElmhurstPain = () => (
  <NeighborhoodPainPost
    data={{
      neighborhood: 'Elmhurst',
      slug: 'back-and-neck-pain-massage-elmhurst',
      image:
        'https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=1600&auto=format&fit=crop&q=80',
      driveMinutes: '8–12 minutes',
      driveNote:
        'the drive from Elmhurst to 2528 I Street via T Street, Folsom Boulevard, or J Street is short and direct',
      routes: [
        'From central Elmhurst: ~10 minutes via T Street or Folsom Boulevard',
        'From near Sac State / Elmhurst border: ~10–12 minutes via J Street',
        'From south Elmhurst: ~8–10 minutes via Broadway and 21st',
      ],
      nearbyAreas: [
        'Elmhurst, Sacramento',
        'East Sacramento',
        'Tahoe Park, Sacramento',
        'Oak Park, Sacramento',
        'Midtown Sacramento',
      ],
      pageTitle:
        'Back and Neck Pain Massage in Elmhurst | Ayumi Suzuki',
      hookLine:
        'Elmhurst resident dealing with chronic back or neck pain and looking for a certified therapist nearby?',
      dataTestId: 'elmhurst-pain-blog-page',
    }}
  />
);

export default BlogPostElmhurstPain;
